import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { confirmAndLogout } from '../../utils/session';
import { useAuth } from '../../context/authContext';

const SuperAdmin = () => {
  const navigate = useNavigate();
  const { user: authUser } = useAuth();

  const getUserString = () => {
    try {
      const s = sessionStorage.getItem('user') || localStorage.getItem('user') || '';
      if (!s) return authUser?.user || '';
      try {
        const o = JSON.parse(s);
        return (o.user || o.id || o.email || o.usuario || o.username || '') + '';
      } catch (_) { return s + ''; }
    } catch (_) { return ''; }
  };

  const handleLogout = () => confirmAndLogout(navigate, '/login');

  useEffect(() => {
    const handlePopState = () => {
      const didLogout = confirmAndLogout(navigate, '/login');
      if (!didLogout) {
        try { window.history.pushState(null, '', window.location.href); } catch (_) {}
      }
    };
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [navigate]);

  const options = [
    { title: 'Compras', image: '/images/compras.png', path: '/superadmin/compras' },
    { title: 'Servicios', image: '/images/servicios.png', path: '/superadmin/servicios' },
    { title: 'Gestionar datos', image: '/images/importar-datos.png', path: '/superadmin/importar' },
  ];

  return (
    <div style={{ ...styles.container, position: 'relative' }}>
      <div style={{ position: 'absolute', top: 12, left: 12, right: 12, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', zIndex: 50 }}>
        <button
          onClick={handleLogout}
          style={{
            padding: '12px 16px',
            borderRadius: 10,
            backgroundColor: '#ef4444',
            color: '#fff',
            border: 'none',
            cursor: 'pointer',
            fontWeight: 800,
            fontSize: 15,
          }}
          title="Cerrar sesión"
        >
          Cerrar sesión
        </button>
      </div>

      <h1 style={styles.title}>Panel Super Admin de <strong style={{ color: '#007bff' }}>{getUserString()}</strong></h1>

      <div style={styles.buttonContainer}>
        {options.map((option) => (
          <button key={option.title} onClick={() => navigate(option.path)} style={styles.button}>
            <img src={option.image} alt={option.title} style={styles.image} />
            <span style={styles.label}>{option.title}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    textAlign: 'center',
    padding: '40px',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  title: {
    marginBottom: '30px',
    color: '#333',
    marginTop: 60,
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    alignItems: 'center',
  },
  button: {
    width: '90%',
    maxWidth: '400px',
    padding: '20px',
    border: '2px solid #007bff',
    borderRadius: '10px',
    backgroundColor: 'transparent',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '20px',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
  },
  image: {
    width: '50px',
    height: '50px',
    objectFit: 'contain',
  },
  label: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#007bff',
    textAlign: 'center',
  },
};

export default SuperAdmin;
